module.exports = __webpack_public_path__ + "static/media/tick.2ccc9f3f.svg";